export const FETCH_MYSTERIES_REQUESTED = 'mysteries/FETCH_MYSTERIES_REQUESTED';
export const FETCH_MYSTERIES_SUCCESS = 'mysteries/FETCH_MYSTERIES_SUCCESS';
export const FETCH_MYSTERIES_FAILURE = 'mysteries/FETCH_MYSTERIES_FAILURE';

export const ANSWER_MYSTERY_REQUESTED = 'mysteries/ANSWER_MYSTERY_REQUESTED';
export const ANSWER_MYSTERY_SUCCESS = 'mysteries/ANSWER_MYSTERY_SUCCESS';
export const ANSWER_MYSTERY_FAILURE = 'mysteries/ANSWER_MYSTERY_FAILURE';

export const REFRESH_MYSTERIES = 'mysteries/REFRESH_MYSTERIES';
